export default __webpack_public_path__ + "images/vetting-logo.v-1b1e3733e8237e4d86618ff452cf4bfb.png";